import { STYLE_CONSTS, COLORS } from "~/src/styles/config.style";
import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  documentsTable: {
    width: "100%",
    borderCollapse: "collapse",
    textAlign: "center",
    fontSize: STYLE_CONSTS.FONT_SMALL,
    letterSpacing: "-0.18px",
    "& thead": {
      backgroundColor: "#F4F4F4",
      borderRadius: "10px",
      fontWeight: STYLE_CONSTS.FONT_WEIGHT_MEDIUM,
      color: COLORS.COOL_GREY,
      "& tr": {
        height: "32px",
        "& th:first-child": {
          borderRadius: "10px 0 0 10px"
        },
        "& th:last-child": {
          borderRadius: "0 10px 10px 0"
        }
      }
    },
    "& tbody": {
      "& tr": {
        height: "42px"
      },
      "& a": {
        textDecoration: "none"
      }
    }
  }
});
